import RestartChallengeForm from './RestartChallengeForm';

export default RestartChallengeForm;
